import { getRoles } from "@/stores/auth.store";
import { some } from "lodash";


const isSuperAdmin = () => getRoles().includes("OWFSA_SUPER_ADMIN");

const isSchedulingAdminOrHigher = () => {
  const roles = getRoles();
  return (
    roles.includes("OWFSA_SUPER_ADMIN") ||
    roles.includes("OWFSA_SCHEDULING_ADMIN")
  );
};

const isSchedulingAdmin = () => {
  const roles = getRoles();
  return roles.includes("OWFSA_SCHEDULING_ADMIN");
};

// facilitator for router
const isAnyRole = () => true;

const isEmployeeOnly = () => !isReviewerOrHigher() && !isLead() && !isSupport();

const isManager = () => some(getRoles(), (role) => role.endsWith("_MGR"));

const isManagerOnTeam = (teamId: string): boolean => {
  return getRoles().some((role) => {
    if (role.endsWith("_MGR")) {
      const teamIdFromRole = role.slice(0, -4);
      return teamIdFromRole === teamId;
    }
    return false;
  });
};

const isLeadOnTeam = (teamId: string): boolean => {
  return getRoles().some((role) => {
    if (role.endsWith("_LEAD")) {
      const teamIdFromRole = role.slice(0, -5);
      return teamIdFromRole === teamId;
    }
    return false;
  });
};

const isSupportOnTeam = (teamId: string): boolean => {
  return getRoles().some((role) => {
    if (role.endsWith("_SUPPORT")) {
      const teamIdFromRole = role.slice(0, -8);
      return teamIdFromRole === teamId;
    }
    return false;
  });
};

const isLead = () => some(getRoles(), (role) => role.endsWith("_LEAD"));

const isSupport = () => some(getRoles(), (role) => role.endsWith("_SUPPORT"));

const isUnionRep = () => some(getRoles(), (role) => role.endsWith("_REP"));

const isTrainer = () => some(getRoles(), (role) => role === "DISPATCH_TRAINER");

const isAuditor = () => some(getRoles(), (role) => role === "DISPATCH_AUDITOR");

const isReviewer = () => isManager() || isUnionRep() || isTrainer() || isAuditor();

const isReviewerOrHigher = () => isSchedulingAdminOrHigher() || isReviewer();

const hasDeskConfigAccessOnTeam = (teamId: string): boolean => {
  if (!teamId) {
    return false;
  }

  if (isSchedulingAdminOrHigher()) {
    return true;
  }

  return isManagerOnTeam(teamId) || isLeadOnTeam(teamId) || isSupportOnTeam(teamId);
};

export {
  isAnyRole,
  isEmployeeOnly,
  isManager,
  isManagerOnTeam,
  isLead,
  isLeadOnTeam,
  isSupport,
  isSupportOnTeam,
  isReviewer,
  isReviewerOrHigher,
  isSchedulingAdmin,
  isSchedulingAdminOrHigher,
  isSuperAdmin,
  isTrainer,
  isUnionRep,
  isAuditor,
  hasDeskConfigAccessOnTeam,
};
